/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:796088e8-b5ff-4c98-9b14-0909d1acfff0",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_SvBDvBHev",
    "aws_user_pools_web_client_id": "674ec158osiiqcfpatnued6kkh",
    "oauth": {
        "domain": "was-nhb-uat.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://uat.negotiators-handbook.ucop.edu/",
        "redirectSignOut": "https://uat.negotiators-handbook.ucop.edu/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://6qj43hlmpzembpxpgkd4egh2ym.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "nhbusersapi",
            "endpoint": "https://wx85a2i9b5.execute-api.us-west-2.amazonaws.com/uat",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
